import DefaultList from "@Common/DefaultList";
import { useNavigationHandler } from "@hook";
import { handleCopyBuffer } from "@utils";
import { inject, observer } from "mobx-react";

const ReplaceDataList = inject("mainStore")(
    observer(({ mainStore }) => {
        const navigation = useNavigationHandler();

        const handleRowClick = (e) => {
            navigation(e.originalEvent, `/replace-data/${e.data._id}`);
        };
        return (
            <DefaultList
                dataKey={"abtest_offerreplaces"}
                apiUrl="/abtest/offerreplaces"
                keysToGet={["_id", "title", "site.name", "offer.title", "replacesData.sortNum", "active", "archived", "draft"]}
                titleName="Замена для офферов"
                titleAddButton="замену"
                keyFilterSearch="name"
                handleRowClick={handleRowClick}
                checkbox={false}
                columns={[
                    {
                        field: "_id",
                        header: "ID",
                        style: { width: "6%", maxWidth: "20px", overflow: "hidden" },
                        body: (item) => (
                            <div className="id__copy cursor-pointer" onClick={(e) => handleCopyBuffer(e, item, "_id", (val) => mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: `Скопировано`, detail: val }))}>
                                <span className=" text">ID</span>
                                <i className="pi pi-clone"></i>
                            </div>
                        ),
                    },
                    {
                        field: "title",
                        header: "Название",
                        body: (item) => <span className="list__name">{item.title}</span>,
                        sortable: true,
                        style: { width: "300px", maxWidth: "300px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                        type: "text",
                    },
                    { field: "site.name", header: "Сайт", sortable: true, style: { width: "25%" }, type: "text" },
                    { field: "offer.title", header: "Оффер", sortable: true, style: { width: "25%" }, type: "text" },
                    { field: `replacesData.sortNum`, header: "Сортировка (тоже заполняем)", sortable: true, style: { width: "10%" }, type: "number" },
                ]}
            />
        );
    }),
);

export default ReplaceDataList;
